module.exports = __webpack_public_path__ + "img/alert.0fee02d6.svg";